/**
 * @license lucide v0.294.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import defaultAttributes from '../defaultAttributes.js';

const Delete = [
  "svg",
  defaultAttributes,
  [
    ["path", { d: "M20 5H9l-7 7 7 7h11a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2Z" }],
    ["line", { x1: "18", x2: "12", y1: "9", y2: "15" }],
    ["line", { x1: "12", x2: "18", y1: "9", y2: "15" }]
  ]
];

export { Delete as default };
//# sourceMappingURL=delete.js.map
